import {Injectable} from '@angular/core';
import {saveAs} from 'file-saver';

@Injectable({
    providedIn: 'root'
})
export class CsvExportService {

    /**
     * Converts a millisecond timestamp to a date string in DD/MM/YYYY hh:mm format in the specified timezone
     * @param {number} milliseconds - The timestamp in milliseconds
     * @return {date: string, time: string} - Date object in the specified timezone
     */
    convertMillisecondsToDate(milliseconds): {date: string, time: string} {
        const timezone = JSON.parse(sessionStorage.getItem("selectedSite")).timezone;
        try {
            // Create a date object from the milliseconds
            const date = new Date(milliseconds);

            // Format options with the specified timezone
            const options: Intl.DateTimeFormatOptions = {
                timeZone: timezone,
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
            };

            // Format the date according to the specified timezone
            const formattedDate = new Intl.DateTimeFormat(
                "en-GB",
                options
            ).format(date);

            const dateTimeArr = formattedDate.split(', ');
            const dateObj = {date: dateTimeArr[0], time: dateTimeArr[1]};
            return dateObj;
        } catch (error) {
            console.log(`Error: ${error.message}`);
            return null;
        }
    }

    private saveToCsv(headerRow1: string[], headerRow2: string[], data: Array<Array<string | number | null>>, fileName: string): void {
        const replacer = (key, value) => value === null ? '' : value;

        //Remove ",", ";" character from headerRow1 if any because these characters will cause
        // spliting cell in csv file
        headerRow1 = headerRow1.map(item => {
            item = item.replaceAll(',', '');
            item = item.replaceAll(';', '');
            return item;
        })
        // Combine header rows
        let csv = [
            headerRow1.map(item => item.replaceAll(',', ' ')).join(','),
            headerRow2.join(',')
        ];

        // Process data rows
        csv = csv.concat(data.map(row =>
            row.map(value => JSON.stringify(value, replacer)).join(',')
        ));

        let csvArray = csv.join('\r\n');

        const blob = new Blob([csvArray], {type: 'text/csv'});
        saveAs(blob, fileName + '.csv');
    }


    exportToCsv(options: Highcharts.Options, fileName: string) {
        const headers = ['', '', ''];
        const firstRow = ['Date', 'Timezone', 'Time'];
        const timezone = options?.time?.timezone;

        // Create an efficient timestamp index
        const timeIndex = new Map<string, {
            values: Map<string, string | null>,
            timestamp: number
        }>();

        // Single pass through data
        options.series.forEach((series, seriesIndex) => {
            headers.push(series.name);
            firstRow.push(`Unit: ${options.yAxis[series.yAxis as number].title.text}`);

            // @ts-ignore
            series.data?.forEach(point => {
                const timestamp = point.x;
                const value = point.y;
                const date = new Date(timestamp);
                const key = `${date.toISOString().split('T')[0]}-${date.getHours()}:${date.getMinutes()}`;

                if (!timeIndex.has(key)) {
                    timeIndex.set(key, {
                        values: new Map(),
                        timestamp: timestamp
                    });
                }
                timeIndex.get(key)!.values.set(series.name, value?.toFixed(2));
            });
        });

         // Convert to final format in a single operation
         const formattedData = Array.from(timeIndex.entries())
         .sort(([, a], [, b]) => a.timestamp - b.timestamp)
         .map(([, entry]) => {
             const dateObj = this.convertMillisecondsToDate(entry.timestamp);
             let dataPerLine = [
                dateObj.date,
                 timezone,
                 dateObj.time,
                 ...headers.slice(3).map(name => entry.values.get(name) ?? null)
             ];
             return dataPerLine;
         });
        this.saveToCsv(headers, firstRow, formattedData, fileName);
    }
}
